import type { CoachingHistoryResponse, CoachResponse } from '@on3/api';
import { Text } from 'components/UI/Typography/Text';

import { CompactHeader } from '../Header/CompactHeader';
import styles from './CoachHistory.module.scss';
import { CoachHistoryItem } from './CoachHistoryItem';

export const CoachHistory = ({
  list,
  coach,
}: {
  list?: CoachingHistoryResponse[];
  coach?: CoachResponse;
}) => {
  return (
    <section className={styles.historyListContainer}>
      {coach?.fullName ? (
        <CompactHeader coachInfo={coach} />
      ) : (
        <header>
          <Text className={styles.title} variant="h6">
            Coaching History
          </Text>
        </header>
      )}

      {list?.map((history) => (
        <div
          className={styles.historyListWrapper}
          key={`${history.organization?.key}-${history.startPsoKey}`}
        >
          <CoachHistoryItem coachHistoryItems={history} />
        </div>
      ))}
    </section>
  );
};
